import React, { FC } from "react";

import { faAngleDown } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { bem } from "@react-md/utils";
import AntdDropdown, { DropdownButtonProps as AntdDropdownButtonProps } from "antd/es/dropdown";
import cn from "classnames";

const block = bem("mmc-dropdown");

export interface DropdownButtonProps extends AntdDropdownButtonProps {
  hasMenu?: boolean;
}

const DropdownButton: FC<DropdownButtonProps> = ({
  children,
  className,
  hasMenu,
  icon,
  menu,
  ...props
}) => {
  return (
    <AntdDropdown.Button
      className={cn(block("button"), className)}
      icon={hasMenu ? <FontAwesomeIcon icon={faAngleDown} /> : icon}
      menu={{ ...menu, className: cn(block("menu"), menu?.className) }}
      {...props}
    >
      {children}
    </AntdDropdown.Button>
  );
};

export default DropdownButton;
